module.exports = __webpack_public_path__ + "static/media/ELEMENTOS_ICONO2 SECCION3.1436cdef.png";